import { v4 as uuidv4 } from "uuid";
export const header = [{
    path: '',
    id: 'clfzj',
    list: [
        {
            components: () => import("@/views/clfzj/components/one.vue"),
            name: "首页",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/clfzj/components/two.vue"),
            name: "功能架构",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/clfzj/components/three.vue"),
            name: "系统特点",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/clfzj/components/four_1.vue"),
            name: "系统优势",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/clfzj/components/four.vue"),
            name: "平台展示",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/clfzj/components/five.vue"),
            name: "典型案例",
            id: uuidv4(),
        },
        /*{
            components: () => import("@/views/clfzj/components/six.vue"),
            name: "新闻中心",
            id: uuidv4(),
        },*/
    ]
}, {
    path: '',
    id: 'home',
    list: [
        {
            components: () => import("@/views/home/components/one.vue"),
            name: "首页",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/home/components/two.vue"),
            name: "功能架构",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/home/components/three.vue"),
            name: "平台优势",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/home/components/four.vue"),
            name: "平台展示",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/home/components/five.vue"),
            name: "典型案例",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/home/components/seven.vue"),
            name: "新闻中心",
            id: uuidv4(),
        },
    ]
}, {
    path: '',
    id: 'jzxj',
    list: [
        {
            components: () => import("@/views/jzxj/components/one.vue"),
            name: "首页",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/jzxj/components/two.vue"),
            name: "功能架构",
            id: uuidv4(),
        },
        //   {
        //     components: () => import("@/views/jzxj/components/three.vue"),
        //     name: "平台优势",
        //     id: uuidv4(),
        //   },
        {
            components: () => import("@/views/jzxj/components/four.vue"),
            name: "平台优势",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/jzxj/components/five.vue"),
            name: "平台展示",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/jzxj/components/six.vue"),
            name: "典型案例",
            id: uuidv4(),
        },
    ]
}, {
    path: '',
    id: 'wxzj',
    list: [
        {
            components: () => import("@/views/wxzj/components/one.vue"),
            name: "首页",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/wxzj/components/two.vue"),
            name: "功能架构",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/wxzj/components/three.vue"),
            name: "平台特点",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/wxzj/components/four.vue"),
            name: "平台展示",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/wxzj/components/five.vue"),
            name: "典型案例",
            id: uuidv4(),
        },
        /*{
            components: () => import("@/views/wxzj/components/six.vue"),
            name: "新闻中心",
            id: uuidv4(),
        },*/
    ]
}, {
    path: '',
    id: 'yljr',
    list: [
        {
            components: () => import("@/views/yljr/components/one.vue"),
            name: "首页",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/yljr/components/two.vue"),
            name: "功能架构",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/yljr/components/three.vue"),
            name: "平台成效",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/yljr/components/four.vue"),
            name: "平台优势",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/yljr/components/five.vue"),
            name: "平台展示",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/yljr/components/six.vue"),
            name: "典型案例",
            id: uuidv4(),
        },
        // {
        //     components: () => import("@/views/yljr/components/seven.vue"),
        //     name: "新闻中心",
        //     id: uuidv4(),
        // },
    ]
}, {
    path: '',
    id: 'yszj',
    list: [
        {
            components: () => import("@/views/yszj/components/one.vue"),
            name: "首页",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/yszj/components/two.vue"),
            name: "功能架构",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/yszj/components/three.vue"),
            name: "平台创新",
            id: uuidv4(),
        },
        // {
        //     components: () => import("@/views/yszj/components/four.vue"),
        //     name: "监督平台",
        //     id: uuidv4(),
        // },
        {
            components: () => import("@/views/yszj/components/five.vue"),
            name: "平台特点",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/yszj/components/six.vue"),
            name: "平台展示",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/yszj/components/seven.vue"),
            name: "典型案例",
            id: uuidv4(),
        },
        /*{
            components: () => import("@/views/yszj/components/eight.vue"),
            name: "新闻中心",
            id: uuidv4(),
        },*/
    ]
}, {
    path: '',
    id: 'zfbz',
    list: [
        {
            components: () => import("@/views/zfbz/components/one.vue"),
            name: "首页",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/zfbz/components/two.vue"),
            name: "功能架构",
            id: uuidv4(),
        },
        // {
        //   components: () => import("@/views/zfbz/components/three.vue"),
        //   name: "平台成效",
        //   id: uuidv4(),
        // },
        {
            components: () => import("@/views/zfbz/components/four.vue"),
            name: "平台优势",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/zfbz/components/five.vue"),
            name: "平台展示",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/zfbz/components/six.vue"),
            name: "典型案例",
            id: uuidv4(),
        },/* {
            components: () => import("@/views/zfbz/components/seven.vue"),
            name: "新闻中心",
            id: uuidv4(),
        },*/
    ]
}, {
    path: '',
    id: 'zfjr',
    list: [
        {
            components: () => import("@/views/zfjr/components/one.vue"),
            name: "首页",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/zfjr/components/two.vue"),
            name: "功能架构",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/zfjr/components/three.vue"),
            name: "存房业务",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/zfjr/components/four.vue"),
            name: "特色网点",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/zfjr/components/five.vue"),
            name: "创新应用",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/zfjr/components/six.vue"),
            name: "平台优势",
            id: uuidv4(),
        }, {
            components: () => import("@/views/zfjr/components/seven.vue"),
            name: "平台展示",
            id: uuidv4(),
        }, {
            components: () => import("@/views/zfjr/components/eight.vue"),
            name: "社会价值",
            id: uuidv4(),
        }, {
            components: () => import("@/views/zfjr/components/nine.vue"),
            name: "典型案例",
            id: uuidv4(),
        },
    ]
}, {
    path: '',
    id: 'zhxyw',
    list: [
        {
            components: () => import("@/views/zhxyw/components/one.vue"),
            name: "首页",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/zhxyw/components/two.vue"),
            name: "功能架构",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/zhxyw/components/three.vue"),
            name: "典型案例",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/zhxyw/components/four.vue"),
            name: "平台展示",
            id: uuidv4(),
        },
        // {
        //     components: () => import("@/views/zhxyw/components/five.vue"),
        //     name: "校友大数据",
        //     id: uuidv4(),
        // },
        {
            components: () => import("@/views/zhxyw/components/six.vue"),
            name: "返校案例",
            id: uuidv4(),
        },
        {
            components: () => import("@/views/zhxyw/components/seven.vue"),
            name: "运营服务",
            id: uuidv4(),
        },
        /*{
            components: () => import("@/views/zhxyw/components/eight.vue"),
            name: "新闻中心",
            id: uuidv4(),
        },*/
    ]
}]